<div class="empty-box my-3">
  <div class="empty-content">
    <div class="empty-icon">🗂️</div>
    <h5>{{ title }}</h5>
  </div>
</div>

<!-- <div class="container-fluid text-center">
  <img src="./assets/img/qa-empty.png" id="" alt="" class="mt-5" />
  <h3 class="text-center mt-5">No Records Found !!!</h3>
</div> -->
